import type { TournamentRoundsApi } from '@/v2/api/metadata/tournament-rounds'
import { createFeedConfigDialogApi } from '@/v2/kits/feed-config'
import { tournamentRoundId } from '../../shared'

export function createTournamentRoundFeedConfigApi(roundsApi: TournamentRoundsApi) {
  return createFeedConfigDialogApi(({ values }) => tournamentRoundId(values), {
    getFeedTypeMappings: roundsApi.getFeedTypeMappings.bind(roundsApi),
    getFeedInstanceMappings: roundsApi.getFeedInstanceMappings.bind(roundsApi),
    updateEntity: async (entityId, payload) => {
      await roundsApi.update(entityId, payload)
    },
  })
}
